// Dependencies
import React from 'react';

// import { EVENT_TYPE, FORM_NAME } from '../../../../../lib/analytics-constants';
import { RentVsBuyInput } from '../../../../../lib/utils';
import { LEGACY_FIELD_NAMES } from '../../../analytics-constants';
import HomeAppreciationInput from '../home-appreciation';

const CONTROL_PANEL = 'controlPanel';

const analyticsPayload = {
  enabled: true,
  payload: {
    legacy: {
      formName: CONTROL_PANEL,
      fieldName: LEGACY_FIELD_NAMES.HOME_APPRECIATION,
    },
    // bedrock: {
    //   eventType: EVENT_TYPE.HOME_APPRECIATION_PERCENT_UPDATED,
    //   form_name: FORM_NAME.RENT_VS_BUY_CALCULATOR,
    //   was_prefilled: true,
    //   page_number: null,
    //   total_pages: null,
    //   additional_attributes: {
    //     housing_type: 'home',
    //   },
    // },
  },
};
const HomeAppreciationInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <HomeAppreciationInput
      label={label}
      tooltip={tooltip}
      analytics={analyticsPayload}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default HomeAppreciationInputWithAnalytics;
